import 'lazysizes';
import { utils } from './modules/utils';
import { modal } from './modules/modal';
import { Other } from './modules/other';

/* = Globals ================================================== */

var ELEMENTS = [
  {
    type: Other,
    element: ".option--other"
  }
];

var uma = null;
var uim = null;

/* = AJAX UI manager ================================================== */

uma = {
  events: {
    initialized: new CustomEvent('ajax-initialized'),
    refreshed: new CustomEvent('ajax-refreshed'),
    changed: new CustomEvent('ajax-changed'),
    load_modules: new CustomEvent('load-modules'),
  },
  init: () => {
    uma.mount();
    setTimeout(function () {
      uma.clear_excludes();
    }, 1);
    document.dispatchEvent(uma.events.initialized);
    document.getElementById('mgmt').dispatchEvent(uma.events.initialized);
    window.uma = uma;
  },
  mount: function () {
    console.log('mounting ajax manager');
  },
  // Scripts to update wordpress admin bar
  /*
  update_wp_admin_bar: (data) => {
    if (!document.body.classList.contains("logged-in")) { return; }

    let tempDiv = document.createElement("div");
    tempDiv.innerHTML = data.html;
    let returned = tempDiv.querySelector("#wpadminbar")?.innerHTML;

    if (returned) {
      document.querySelector("#wpadminbar").innerHTML = returned;
    }

    uma.clear_excludes();
  },
  */
  on_click: () => {

  },
  on_load: (new_page_data) => {
    document.dispatchEvent(uma.events.refreshed);
    document.getElementById('mgmt').dispatchEvent(uma.events.refreshed);
    //uma.update_wp_admin_bar(new_page_data);
    uim.onLoadScripts();
  },
  // use barba to navigate to a specific url
  go: (url) => {
  },
  // Set the state of the app
  set_state: (state) => {
    document.body.dataset.state = state;
  },
  // Remove djax links from page
  clear_excludes: () => {
    if (document.getElementById('wpadminbar') === null) return;
    document.getElementById('wpadminbar').setAttribute('data-barba-prevent', 'all');
  },
};

/* = UI Manager ================================================== */

uim = {
  screenWidth: window.innerWidth,
  elementChecks: ELEMENTS,

  init: () => {
    console.log("UI Manager is now initiated");
    uma.init();
    uim.initialLoadScripts();
    uim.onLoadScripts();
    document.dispatchEvent(uma.events.load_modules);
    window.uim = uim;
  },

  // Iterate through elementChecks array
  runChecks: (elements) => {
    //console.log("|__ running checks");

    for (var i = 0; i < elements.length; i++) {
      console.log(
        "  |__ running check on: " + elements[i].element
      );
      if (document.body.contains(document.querySelector(elements[i].element)))
        console.log("    |__ check passed");
      let elems = document.querySelectorAll(elements[i].element);

      for (let index = 0; index < elems.length; index++) {
        const element = elems[index];
        uim.assign(element, elements[i].type);
      }
    }
  },

  // assign objects to elements
  assign: (elem, type) => {
    //console.log("      |__ creating object ...");
    var new_obj = new type(elem);
    new_obj.init();
  },

  // Only load these scripts initially
  initialLoadScripts: () => {
    console.log("|__ running initial scripts");
  },

  // onload functions that load on every page
  onLoadScripts: () => {
    console.log("|__ running onload scripts");
    uim.runChecks(ELEMENTS);
  },
};
uim.init();